// import React from "react";
// import { useEffect, useState } from "react";
// import { useHistory } from "react-router-dom";
// import { Dashboard } from "./Dashboard";
// import { GetAllSegments } from "../../../api/CMS";
// import { toast } from "react-toastify";

// export default function VideoDashboardPage() {
//   const user = JSON.parse(localStorage.getItem("user"));
//   const userAdminToken = sessionStorage.getItem("jwtP");
//   const history = useHistory();
//   const [isOpen, setIsOpen] = useState(false);
//   const [users, setUsers] = useState([]);
//   const [currentUser, setCurrentUser] = useState(null);
//   const [records, setRecords] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [classTypes, setClassTypes] = useState([]); // for modal
//   const [selectedClassTypeId, setSelectedClassTypeId] = useState(null); // which accordion is open

//   const getAllData = async () => {
//     try {
//       setIsLoading(true);
//       const res = await GetAllSegments(user.Token);

//       if (res.data.ResponseStatus === 1) {
//         const response = res.data.ResponseData;
//         // Log once to inspect the shape

//         // Store full data for filtering later
//         // setAllCourseData(response);

//         // Extract unique ClassTypeIds for modal

//         setClassTypes(response); // we’ll add this new state below

//         setIsOpen(true);
//       } else {
//         toast.error("Veri alınamadı. Lütfen tekrar deneyiniz.");
//         history.push("./userprofile");
//       }
//     } catch (error) {
//       console.error("Error fetching class type topics:", error);
//       toast.error("Bir hata oluştu, lütfen yetkililerle iletişime geçiniz.");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     getAllData();
//   }, []);

//   //   const handleChangeUser = async (userId) => {
//   //     const user = users.find((u) => u.id === userId);
//   //     setCurrentUser(user);

//   //     const res = await fetch(`/api/videos?userId=${userId}`);
//   //     const videos = await res.json();

//   //     setRecords(videos);
//   //   };

//   const handleEdit = (videoId) => {
//     history.push(`/admin/video-builder/${videoId}`);
//   };

//   if (!currentUser) return null;

//   return (
//     <>
//       {isOpen && (
//         <div className="modal">
//           <div className="modal-content">
//             <div style={{ textAlign: "center" }}>
//               <h2>Lütfen Sınav Seçimi Yapınız</h2>
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-around",
//                   flexWrap: "wrap",
//                 }}
//               >
//                 {classTypes.map((classType) => (
//                   <button
//                     key={classType.ClassTypeId}
//                     style={{ padding: 10, width: "30%", marginBottom: 10 }}
//                     onClick={() => {
//                       setSelectedClassTypeId(classType.Id);
//                       localStorage.setItem("selectedClassTypeId", classType.Id);
//                     }}
//                   >
//                     {classType.ClassTypeName}
//                     {classType.ExamTypeId > 0 && ` - ${classType.ExamTypeName}`}
//                   </button>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       <Dashboard
//         users={users}
//         currentUser={currentUser}
//         records={records}
//         isLoading={isLoading}
//         //   onChangeUser={handleChangeUser}
//         onEdit={handleEdit}
//       />
//     </>
//   );
// }

import React, { useEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";
import SideBar from "../../../components/SideBar";
import { Components } from "../../../assets/Dimensions";
import { ToastContainer, toast } from "react-toastify";
import "../../questionVideoSolution/style.css";

import ExamType from "../../../enums/ExamType";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";

import { useHistory } from "react-router-dom";
import Loader from "@material-ui/core/CircularProgress";

import {
  GetAllSegments,
  GetSegmentCourses,
  GetSegmentTopics,
} from "../../../api/CMS";
import { getAchievementInteractionVideos, getCourseInteractionVideos, openInteractionVideo } from "../../../api/VideoInteractions/videoInteractions";
import ContentType from "../../../enums/ContentType";
import { Dashboard } from "./Dashboard";
import { VIDEO_STATUS_DEFINITIONS } from "../constants/videoStatus";
import BackButton from "../../../components/Base/BackButton";


const TaskStatusLabelsTr = {
  1: "Yapılacak",
  2: "Yapılıyor",
  3: "İnceleme Bekliyor",
  4: "Onaylanmadı",
  5: "Tamamlandı",
  6: "Hatalı",
};

const TaskStatusColors = {
  1: "#3b82f6", // Todo - blue
  2: "#f59e0b", // InProgress - amber
  3: "#eab308", // PendingReview - yellow
  4: "#ef4444", // Reject - red
  5: "#22c55e", // Approve - green
  6: "#6b7280", // HasError - gray
};

// Tally a course's video Details by VideoStatus (0/1/2). Always returns all
// three buckets so cards can show every label, including zeros.
const countDetailsByVideoStatus = (details = []) => {
  const counts = { 0: 0, 1: 0, 2: 0 };
  details.forEach((item) => {
    if (counts[item.VideoStatus] !== undefined) {
      counts[item.VideoStatus] += 1;
    }
  });
  return counts;
};



const VideoDashboardPage = () => {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 700px)" });
  const user = JSON.parse(localStorage.getItem("user"));
  const userAdminToken = sessionStorage.getItem("jwtP");

  const [nav, setNav] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedExamCategory, setSelectedExamCategory] = useState(null);
  const [coursesData, setCoursesData] = useState([]);
  const [allCourseData, setAllCourseData] = useState(null);
  const [examTypeId, setExamTypeId] = useState(1);
  const [loader, setLoader] = useState(false);
  const [segmentTopics, setSegmentTopics] = useState(null);
  const [classTypes, setClassTypes] = useState([]); // for modal
  const [openCourseId, setOpenCourseId] = useState(null); // which accordion is open
  const [selectedClassTypeId, setSelectedClassTypeId] = useState(null); // which accordion is open
  const [topicsByCourse, setTopicsByCourse] = useState({}); // store fetched topics for each course
  const [view, setView] = useState("courses");
  // "courses" | "videos" | "builder"
  const [videoRecords, setVideoRecords] = useState([]);
  const [isLoadingVideos, setIsLoadingVideos] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);
  // Per-course video-status counts keyed by course.Id, e.g. { 12: { 0: 3, 1: 1, 2: 0 } }.
  // A course missing from this map means its counts are still loading.
  const [videoStatusByCourse, setVideoStatusByCourse] = useState({});
  // Guards against stale responses writing into a newer category's results.
  const videoStatusFetchGenRef = useRef(0);

  const history = useHistory();

  const style = {
    container: {
      //state e bool değer ekle menü butonuna basıldığında css
      //içinde container a margin eklesin hemde navı açsın

      //marginLeft: isTabletOrMobile ? 0 : Components.SideBarWidth + 15,
      paddingLeft: isTabletOrMobile ? 15 : Components.SideBarWidth + 15,
      paddingTop: 20,
      paddingRight: 15,
      marginBottom: 20,
    },
    editIcon: {
      width: Components.Image.Big.Width,
      height: Components.Image.Big.Height,
    },
    iconButton: {
      marginLeft: 10,
      padding: 0,
    },
  };

  const getExamTypeName = (value) => {
    for (const key in ExamType) {
      if (ExamType[key] === value) {
        return key;
      }
    }
    return null; // Return null if the value is not found
  };

  const groupByTitle = (items) => {
    return items.reduce((acc, curr) => {
      if (!acc[curr.Title]) acc[curr.Title] = [];
      acc[curr.Title].push(curr);
      return acc;
    }, {});
  };

  // 🧠 STEP 1: Fetch + Structure ClassType → Courses
  const getAllData = async () => {
    const getSelctedClassTypeFromLocal = JSON.parse(
      localStorage.getItem("selectedClassTypeId")
    );
    try {
      setLoader(true);
      const res = await GetAllSegments(user.Token);

      if (res.data.ResponseStatus === 1) {
        const response = res.data.ResponseData;
        localStorage.setItem("MaarifModelData", JSON.stringify(response));
        // Log once to inspect the shape

        // Store full data for filtering later
        setAllCourseData(response);

        // Extract unique ClassTypeIds for modal
        const classTypeIds = response.map((item) => ({
          ClassTypeId: item.ClassTypeId,
          ClassTypeName: item.ClassTypeName || "Bilinmeyen Tür",
        }));

        setClassTypes(response); // we’ll add this new state below
        if (getSelctedClassTypeFromLocal) {
          setSelectedClassTypeId(getSelctedClassTypeFromLocal);
          selectExamCategory(getSelctedClassTypeFromLocal);
        } else {
          setIsOpen(true);
        }
      } else {
        toast.error("Veri alınamadı. Lütfen tekrar deneyiniz.");
        history.push("./userprofile");
      }
    } catch (error) {
      console.error("Error fetching class type topics:", error);
      toast.error("Bir hata oluştu, lütfen yetkililerle iletişime geçiniz.");
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getAllData();
  }, []);

  // Fetch per-course video-status (0/1/2) counts so the breakdown is visible on
  // each course card BEFORE entering the course. There is no backend aggregate
  // for this, so we fetch each course's videos and count them client-side.
  // ~10 courses per category, so we fire all calls in parallel and fill each
  // card in as its response lands (incremental render).
  useEffect(() => {
    if (!Array.isArray(coursesData) || coursesData.length === 0) {
      setVideoStatusByCourse({});
      return;
    }

    const gen = ++videoStatusFetchGenRef.current;
    setVideoStatusByCourse({}); // reset -> cards show "loading" until counts arrive

    coursesData.forEach((course) => {
      getAchievementInteractionVideos(user.Token, { SegmentCourseId: course.Id })
        .then((res) => {
          if (gen !== videoStatusFetchGenRef.current) return; // category changed
          const details =
            res?.data?.ResponseStatus === 1
              ? res.data.ResponseData?.Details || []
              : [];
          const counts = countDetailsByVideoStatus(details);
          setVideoStatusByCourse((prev) => ({ ...prev, [course.Id]: counts }));
        })
        .catch(() => {
          if (gen !== videoStatusFetchGenRef.current) return;
          setVideoStatusByCourse((prev) => ({
            ...prev,
            [course.Id]: countDetailsByVideoStatus([]),
          }));
        });
    });
    // user.Token is a stable string read from localStorage.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coursesData, user.Token]);

  const selectExamCategory = async (id) => {
    setSelectedExamCategory(id);

    try {
      setLoader(true);
      const res = await getCourseInteractionVideos(user.Token, id);

      if (res.data.ResponseStatus === 1) {
        const response = res.data.ResponseData;

        setCoursesData(response);
      } else {
        localStorage.removeItem("selectedClassTypeId");
        toast.error("Veri alınamadı. Lütfen tekrar deneyiniz.");
        history.push("./userprofile");
      }
    } catch (error) {
      localStorage.removeItem("selectedClassTypeId");
      console.error("Error fetching class type topics:", error);
      toast.error("Bir hata oluştu, lütfen yetkililerle iletişime geçiniz.");
    } finally {
      setLoader(false);
    }

    setIsOpen(false);
  };

  const loadCourseVideos = async (course) => {
    history.push({
        pathname: "/VideoInteractionDashboard/videos",
        state: {
          user,
          selectedCourse: course
        }
      });
    // try {
    //   setIsLoadingVideos(true);
    //     const payload = {
    //         SegmentCourseId: course.Id,

    //     }
    //   const res = await getAchievementInteractionVideos(
    //     user.Token,
    //     payload
    //   );

    //   if (res.data.ResponseStatus === 1) {
    //     const response = res.data.ResponseData;

    //     const mapped = response.Details.map((item) => ({
    //       id: item.AchievementVideoId,
    //       AchievementId: item.AchievementId,
    //       title: item.AchievementVideoTitle,
    //       status: item.VideoInteractionStatus,
    //       updatedAt: item.ModifiedDate,
    //       ownerName: `${item.Teacher?.Name ?? ""} ${
    //         item.Teacher?.Surname ?? ""
    //       }`,
    //       lesson: course.Name,
    //     }));

    //     setVideoRecords(mapped);
    //     setSelectedCourse(course);
    //     history.push({
    //         pathname: "/VideoInteractionDashboard/videos",
    //         state: {
    //           user,
    //           selectedCourse: course
    //         }
    //       });
    //   } else {
    //     toast.error("Video listesi alınamadı.");
    //   }
    // } catch (err) {
    //   toast.error("Video listesi alınırken hata oluştu.");
    // } finally {
    //   setIsLoadingVideos(false);
    // }
  };

  const handleEditVideo = async (achievementVideoId) => {
    try {
      setLoader(true);
        const payload = {
            AchievementVideoId:achievementVideoId
        }
      const res = await openInteractionVideo(
        user.Token,
        payload
      );
  
      if (res.data.ResponseStatus === 1) {
        const video = res.data.ResponseData;
  
        history.push({
          pathname: "/VideoInteraction",
          state: {
            builderData: video,
          },
        });
      } else {
        toast.error("Video bilgisi alınamadı.");
      }
    } catch (err) {
      toast.error("Video yüklenirken hata oluştu.");
    } finally {
      setLoader(false);
    }
  };
  

//   if (view === "videos") {
//     return (
//       <>
//         <SideBar />
  
//         <div style={style.container}>
//           <Dashboard
//             users={[]} // optional
//             currentUser={{
//               role: user.Role === "ContentManagers"?"admin":"teacher",
//               id: user.Id,
//               lesson: selectedCourse?.Name,
//             }}
//             records={videoRecords}
//             isLoading={isLoadingVideos}
//             onChangeUser={() => {}}
//             onEdit={handleEditVideo}
//           />
//         </div>
//       </>
//     );
//   }
  

  // Per-status totals summed across the course list, plus an overall grand
  // total. Shown next to the status legend.
  const statusTotals = coursesData.reduce((acc, course) => {
    if (Array.isArray(course.Counts)) {
      course.Counts.forEach((item) => {
        acc[item.TaskStatus] = (acc[item.TaskStatus] || 0) + (item.Count || 0);
      });
    }
    return acc;
  }, {});
  const grandTotal = Object.values(statusTotals).reduce(
    (sum, count) => sum + count,
    0
  );

  // Video-status (0/1/2) totals summed across every course, shown in the top
  // legend so the whole category can be assessed at a glance.
  const videoStatusTotals = Object.values(videoStatusByCourse).reduce(
    (acc, counts) => {
      VIDEO_STATUS_DEFINITIONS.forEach((def) => {
        acc[def.value] = (acc[def.value] || 0) + (counts[def.value] || 0);
      });
      return acc;
    },
    {}
  );

  return (
    <>
      {isTabletOrMobile ? (
        <div>
          <span
            style={{ position: "absolute", top: 10, right: 10 }}
            onClick={() => setNav(!nav)}
          >
            menu
          </span>
          {nav && <SideBar />}
        </div>
      ) : (
        <SideBar />
      )}

      {loader && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <Loader size={100} />
        </div>
      )}

      <div style={style.container}>
      <BackButton />
        {isOpen && (
          <div className="modal">
            <div className="modal-content">
              <div style={{ textAlign: "center" }}>
                <h2>Lütfen Sınav Seçimi Yapınız</h2>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    flexWrap: "wrap",
                  }}
                >
                  {classTypes.map((classType) => (
                    <button
                      key={`${classType.ClassTypeId}_${classType.ExamTypeName}`}
                      style={{ padding: 10, width: "30%", marginBottom: 10 }}
                      onClick={() => {
                        setSelectedClassTypeId(classType.Id);
                        selectExamCategory(classType.Id);
                        localStorage.setItem(
                          "selectedClassTypeId",
                          classType.Id
                        );
                      }}
                    >
                      {classType.ClassTypeName}
                      {classType.ExamTypeId > 0 &&
                        ` - ${classType.ExamTypeName}`}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}

        <div style={{ fontWeight: "bold", fontSize: "20px" }}>
          Etkileşimli Video Paneli
        </div>
        {selectedExamCategory && (
          <div
            style={{
              display: "flex",
              flexDirection: "row-reverse",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 10,
              margin: 10,
            }}
          >
            <div
              style={{
                borderWidth: 2,
                borderColor: "black",
                borderRadius: 8,
                padding: 10,
                borderStyle: "solid",
                cursor: "pointer",
                alignItems: "center",
                display: "flex",
              }}
              onClick={function () {
                setIsOpen(true);
              }}
            >
              {(() => {
                const found = classTypes.find(
                  (type) => type.Id === selectedExamCategory
                );
                if (!found) return "Sınıf Türü Seçili Değil";
                return `${found.ClassTypeName}${
                  found.ExamTypeId > 0 ? ` - ${found.ExamTypeName}` : ""
                }`;
              })()}

              <IconButton style={style.iconButton}>
                <EditIcon style={style.editIcon} />
              </IconButton>
            </div>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "12px",
                padding: "10px 0",
                alignItems: "center",
              }}
            >
              {Object.entries(TaskStatusLabelsTr)
                .filter(([key]) => key !== "0") // skip "Yok"
                .map(([key, label]) => (
                  <div
                    key={key}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      fontSize: 14,
                    }}
                  >
                    <div
                      style={{
                        width: 16,
                        height: 16,
                        borderRadius: 4,
                        backgroundColor: TaskStatusColors[key],
                      }}
                    ></div>
                    <span>
                      {label} ({statusTotals[key] || 0})
                    </span>
                  </div>
                ))}

              {/* Overall total across all statuses */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  fontSize: 14,
                  fontWeight: "bold",
                  borderLeft: "1px solid #d1d5db",
                  paddingLeft: 12,
                }}
              >
                <span>Toplam: {grandTotal}</span>
              </div>
            </div>
          </div>
        )}

        {selectedExamCategory && (
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 12,
              padding: "0 0 12px",
              alignItems: "center",
            }}
          >
            <span style={{ fontWeight: "bold", fontSize: 14 }}>
              Video Durumları:
            </span>
            {VIDEO_STATUS_DEFINITIONS.map((def) => (
              <div
                key={`vs-total-${def.value}`}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  fontSize: 14,
                  fontWeight: 600,
                }}
              >
                <span
                  style={{
                    width: 12,
                    height: 12,
                    borderRadius: "50%",
                    backgroundColor: def.dot,
                  }}
                />
                <span style={{ color: def.color }}>
                  {def.label} ({videoStatusTotals[def.value] || 0})
                </span>
              </div>
            ))}
          </div>
        )}

        {coursesData.map((course) => (
          <div key={course.Id}>
            <div
              key={course.Id}
              style={{
                padding: 24,
                borderRadius: 8,
                cursor: "pointer",
                marginBottom: 10,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                transition: "transform 0.15s ease-in-out",
              }}
            >
              {/* --- Top Row: Course Name + Stats --- */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 10,
                }}
              >
                <div style={{ fontSize: 18, fontWeight: "bold" }}>
                  {course.Name}
                </div>

                {/* Stats Container */}
                {course.TotalCount > 0 && (
                  <div
                    style={{
                      backgroundColor: "#fff",
                      borderRadius: 6,
                      padding: "6px 12px",
                      display: "flex",
                      gap: 8,
                      color: "#111",
                      fontWeight: 600,
                      position: "relative",
                      cursor: "default",
                    }}
                    className="stats-container"
                  >
                    {Array.isArray(course.Counts) && course.Counts.length > 0
                      ? course.Counts.map((item) => (
                          <span
                            key={item.TaskStatus}
                            style={{
                              color: TaskStatusColors[item.TaskStatus],
                            }}
                          >
                            {item.Count}
                          </span>
                        ))
                      : null}

                    {/* Tooltip */}
                    <div
                      style={{
                        visibility: "hidden",
                        opacity: 0,
                        position: "absolute",
                        top: "120%",
                        right: 0,
                        backgroundColor: "#fff",
                        color: "#111",
                        padding: "10px 14px",
                        borderRadius: 8,
                        boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                        fontSize: 14,
                        transition: "opacity 0.2s ease, visibility 0.2s ease",
                        zIndex: 10,
                        minWidth: 180,
                      }}
                      className="stats-tooltip"
                    >
                      <ul
                        style={{
                          listStyleType: "disc",
                          margin: 0,
                          paddingLeft: 20,
                        }}
                      >
                        {Array.isArray(course.Counts) &&
                        course.Counts.length > 0
                          ? course.Counts.map((item) => (
                              <li
                                key={item.TaskStatus}
                                style={{
                                  color: TaskStatusColors[item.TaskStatus],
                                  fontWeight: 500,
                                  marginBottom: 4,
                                }}
                              >
                                {TaskStatusLabelsTr[item.TaskStatus]} (
                                {item.Count})
                              </li>
                            ))
                          : null}
                      </ul>
                    </div>
                  </div>
                )}
              </div>

              {/* --- Video status breakdown (0/1/2) for this course --- */}
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 8,
                  marginBottom: 10,
                }}
              >
                {videoStatusByCourse[course.Id] === undefined ? (
                  <span style={{ fontSize: 13, color: "#6b7280" }}>
                    Video durumları yükleniyor...
                  </span>
                ) : (
                  VIDEO_STATUS_DEFINITIONS.map((def) => (
                    <div
                      key={`vs-${course.Id}-${def.value}`}
                      style={{
                        background: "#f3f4f6",
                        padding: "6px 10px",
                        borderRadius: 8,
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                        fontWeight: 600,
                        fontSize: 13,
                      }}
                    >
                      <span
                        style={{
                          width: 10,
                          height: 10,
                          borderRadius: "50%",
                          background: def.dot,
                        }}
                      />
                      <span style={{ color: def.color }}>
                        {def.label}: {videoStatusByCourse[course.Id][def.value] || 0}
                      </span>
                    </div>
                  ))
                )}
              </div>

              {/* --- Bottom Row: Buttons --- */}
              <div
                className="card-buttons"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                  gap: 12,
                  marginTop: 10,
                  flexWrap: "wrap",
                }}
              >
                <button
                  onClick={() => loadCourseVideos(course)}
                  style={{
                    flex: "1 1 45%",
                    maxWidth: 160,
                    minWidth: 120,
                    padding: "10px 0",
                    backgroundColor: "#16a34a",
                    color: "#fff",
                    border: "none",
                    borderRadius: 8,
                    fontWeight: 600,
                    cursor: "pointer",
                    transition: "transform 0.1s ease, opacity 0.2s ease",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "scale(1.03)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                  }
                >
                  Başla
                </button>
              </div>

              <style>
                {`
  /* Responsive fix for desktop */
  @media (min-width: 768px) {
    .card-buttons button {
      flex: none !important;
      width: 150px !important;
    }
  }

  @media (max-width: 767px) {
    .card-buttons button {
      flex: 1 1 45% !important;
      width: 100% !important;
    }
  }
`}
              </style>

              {/* Hover Tooltip Behavior */}
              <style>
                {`
      .stats-container:hover .stats-tooltip {
        visibility: visible !important;
        opacity: 1 !important;
      }
    `}
              </style>
            </div>

            {/* Accordion */}
            {openCourseId === course.Id && (
              <div
                style={{
                  backgroundColor: "#f9fafb",
                  borderRadius: 8,
                  marginTop: 5,
                  padding: "12px 16px",
                }}
              >
                {!topicsByCourse[course.Id] ? (
                  <div style={{ textAlign: "center", padding: 10 }}>
                    Konular yükleniyor...
                  </div>
                ) : (
                  Object.entries(topicsByCourse[course.Id]).map(
                    ([topicTitle, subtopics]) => (
                      <div key={topicTitle} style={{ marginBottom: 12 }}>
                        <div
                          style={{
                            fontWeight: "bold",
                            fontSize: 16,
                            marginBottom: 6,
                            color: "#1f2937",
                          }}
                        >
                          {topicTitle}
                        </div>

                        <div
                          style={{
                            display: "flex",
                            flexWrap: "no-wrap",
                            flexDirection: "column",
                            gap: "8px",
                            marginLeft: 10,
                          }}
                        >
                          {subtopics.map((sub) => (
                            <div
                              key={sub.Id}
                              style={{
                                backgroundColor: "#e5e7eb",
                                borderRadius: 6,
                                padding: "6px 10px",
                                cursor: "pointer",
                                transition: "background 0.2s",
                                display: "flex",
                                alignItems: "center",
                                gap: 10,
                                justifyContent: "space-between",
                              }}
                              onClick={() =>
                                // console.log("states-history", {
                                // courseId: course.Id,
                                // courseName: course.Name,
                                // topicName: topicTitle,
                                // SegmentTopicId: sub.Id,
                                // subTopicName: sub.Name,
                                // // examType: course.ExamType,
                                // classTypeId: selectedExamCategory,
                                // },)
                                history.push({
                                  pathname:
                                    "/NewTopicAndAchSelectionQuestionPage",
                                  state: {
                                    courseId: course.Id,
                                    courseName: course.Name,
                                    topicName: topicTitle,
                                    SegmentTopicId: sub.Id,
                                    subTopicName: sub.Name,
                                    // examType: course.ExamType,
                                    classTypeId: selectedExamCategory,
                                    contentType: ContentType.SubCourseTopic,
                                    segmentId: selectedClassTypeId,
                                    allSegmentData: allCourseData,
                                  },
                                })
                              }
                              onMouseEnter={(e) =>
                                (e.currentTarget.style.backgroundColor =
                                  "#d1d5db")
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.backgroundColor =
                                  "#e5e7eb")
                              }
                            >
                              <div
                                style={{ fontWeight: 600, color: "#111827" }}
                              >
                                {sub.Name}
                              </div>

                              {/* stats pill (same look & tooltip as cards) */}
                              {sub.TotalCount > 0 && (
                                <div
                                  style={{
                                    backgroundColor: "#fff",
                                    borderRadius: 6,
                                    padding: "6px 12px",
                                    display: "flex",
                                    gap: 8,
                                    color: "#111",
                                    fontWeight: 600,
                                    position: "relative",
                                    cursor: "default",
                                  }}
                                  className="stats-container"
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  {Array.isArray(sub.Counts) &&
                                  sub.Counts.length > 0
                                    ? sub.Counts.map((item) => (
                                        <span
                                          key={item.TaskStatus}
                                          style={{
                                            color:
                                              TaskStatusColors[item.TaskStatus],
                                          }}
                                        >
                                          {item.Count}
                                        </span>
                                      ))
                                    : null}

                                  {/* Tooltip */}
                                  <div
                                    style={{
                                      visibility: "hidden",
                                      opacity: 0,
                                      position: "absolute",
                                      top: "120%",
                                      right: 0,
                                      backgroundColor: "#fff",
                                      color: "#111",
                                      padding: "10px 14px",
                                      borderRadius: 8,
                                      boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                                      fontSize: 14,
                                      transition:
                                        "opacity 0.2s ease, visibility 0.2s ease",
                                      zIndex: 10,
                                      minWidth: 180,
                                    }}
                                    className="stats-tooltip"
                                  >
                                    <ul
                                      style={{
                                        listStyleType: "disc",
                                        margin: 0,
                                        paddingLeft: 20,
                                      }}
                                    >
                                      {Array.isArray(sub.Counts) &&
                                      sub.Counts.length > 0
                                        ? sub.Counts.map((item) => (
                                            <li
                                              key={item.TaskStatus}
                                              style={{
                                                color:
                                                  TaskStatusColors[
                                                    item.TaskStatus
                                                  ],
                                                fontWeight: 500,
                                                marginBottom: 4,
                                              }}
                                            >
                                              {
                                                TaskStatusLabelsTr[
                                                  item.TaskStatus
                                                ]
                                              }{" "}
                                              ({item.Count})
                                            </li>
                                          ))
                                        : null}
                                    </ul>
                                  </div>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    )
                  )
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default VideoDashboardPage;
